import { render, staticRenderFns } from "./SwBaseModal.vue?vue&type=template&id=07d772de&"
import script from "./SwBaseModal.vue?vue&type=script&lang=js&"
export * from "./SwBaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d772de')) {
      api.createRecord('07d772de', component.options)
    } else {
      api.reload('07d772de', component.options)
    }
    module.hot.accept("./SwBaseModal.vue?vue&type=template&id=07d772de&", function () {
      api.rerender('07d772de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/base-modal/SwBaseModal.vue"
export default component.exports